'use client';

import { Suspense } from 'react';
import { IProps } from '.';
import OrderDestinationSelector from '../OrderDestinationSelector';

const DeliveryDesktop = ({ handleOpenMap }: IProps) => {
  return (
    <Suspense>
      <OrderDestinationSelector openBranches={handleOpenMap} />
    </Suspense>
  );
};

export default DeliveryDesktop;
